import './Schedule.scss';

import { IconCalendar } from '@hulu-react-style-components/icons';
import React from 'react';

import DaypartTabs from '../../../../../../../../../common/AdForm/Scheduling/DaypartTabs';
import bem from '../../../../../../../../../utils/bem';
import MultipleEditDatesInfo from './MultipleEditDatesInfo';

const [block, element] = bem('multi-edit-schedule');

const DATES_TITLE = 'Dates';

export default function Schedule(): JSX.Element {
  return (
    <div className={block()}>
      <p className={element('subtitle')}>Schedule change applied here will OVERRIDE existing schedule on your ad(s).</p>
      <div className={element('date-title')}>
        <IconCalendar />
        <h5>{DATES_TITLE}</h5>
      </div>
      <MultipleEditDatesInfo editMode={true} readonly={false} />
      <DaypartTabs readonly={false} />
    </div>
  );
}
